// ────────────────────────────────────────────────────────────────────────
//  translations-legal.js
//
//  Translation keys for the 5 legal/compliance policy pages:
//    Terms, Privacy, Refund, Shipping, Contact
//
//  HOW TO USE:
//  Import into translations.js as ES module:
//    import { legalEN, legalAR } from './translations-legal'
//
//  Arabic status:
//  - Navigation, titles, TOC, labels, contact strings: TRANSLATED.
//  - Long legal paragraphs: still prefixed  — pending professional
//    translation by a Qatar legal translation agency.
//
//  Naming convention: every key is prefixed legal* to avoid collision.
// ────────────────────────────────────────────────────────────────────────

const legalEN = {
  legalTermsTocAbout: "About MobiMart",
  legalTermsTocAccounts: "Accounts",
  legalTermsTocBuyers: "Buyers",
  legalTermsTocVendors: "Vendors",
  legalTermsTocListings: "Listings & Content",
  legalTermsTocOrders: "Orders & Payment",
  legalTermsTocDelivery: "Delivery",
  legalTermsTocReturns: "Returns & Refunds",
  legalTermsTocProhibited: "Prohibited Conduct",
  legalTermsTocIP: "Intellectual Property",
  legalTermsTocLiability: "Limitation of Liability",
  legalTermsTocTermination: "Termination",
  legalTermsTocLaw: "Governing Law",
  legalTermsTocChanges: "Changes to These Terms",
  legalTermsTocContact: "Contact",
  legalTermsAboutTitle: "About MobiMart",
  legalTermsAboutP1: "MobiMart is an online marketplace operated by JASPR Trading Contracting and Services (Commercial Registration CR-223480), based at Building 43, Street 310, Zone 27, Doha, State of Qatar (referred to in these terms as \"we\", \"us\", \"MobiMart\"). We connect buyers in Qatar with verified vendors offering mobile phones, accessories, and related products.",
  legalTermsAboutP2: "MobiMart is licensed under Ministerial Decision No. 25 of 2026 on E-Commerce Activities, issued by the Ministry of Commerce and Industry, State of Qatar. Our e-commerce licence number will be displayed in the site footer once issued.",
  legalTermsAccountsTitle: "Accounts",
  legalTermsAccountsP1: "To buy or sell on MobiMart you must register an account and provide accurate information. You are responsible for the security of your password and for all activity on your account.",
  legalTermsEligibilityTitle: "Eligibility",
  legalTermsEligibility1: "You must be at least 18 years old, or have parental consent.",
  legalTermsEligibility2: "You must provide a valid Qatar mobile number and a working email address.",
  legalTermsEligibility3: "Vendor accounts also require Commercial Registration details, valid identification, and banking information for payouts.",
  legalTermsAccountsP2: "We may suspend or terminate any account that provides false information, breaches these terms, or uses MobiMart for fraudulent activity.",
  legalTermsBuyersTitle: "Buyers",
  legalTermsBuyersIntro: "As a buyer you agree to:",
  legalTermsBuyers1: "Provide accurate delivery information.",
  legalTermsBuyers2: "Pay the full order amount via the payment methods MobiMart offers.",
  legalTermsBuyers3: "Inspect items on delivery and report any issues within the timeframes set out in our Refund Policy.",
  legalTermsBuyers4: "Treat vendors and customer service representatives with respect.",
  legalTermsVendorsTitle: "Vendors",
  legalTermsVendorsIntro: "Vendors operate independent businesses and use MobiMart as a platform to reach customers. As a vendor you agree to:",
  legalTermsVendors1: "Hold a valid Qatar Commercial Registration covering the goods you sell.",
  legalTermsVendors2: "Submit Know-Your-Customer (KYC) documents for verification before listing products.",
  legalTermsVendors3: "List only goods you legally own and are entitled to sell.",
  legalTermsVendors4: "Provide accurate descriptions, photographs, and pricing.",
  legalTermsVendors5: "Honour stated stock levels and delivery timelines.",
  legalTermsVendors6: "Pack and dispatch orders within the agreed timeframe.",
  legalTermsVendors7: "Issue refunds promptly when warranted under these terms or our Refund Policy.",
  legalTermsVendors8: "Pay the applicable platform fees set out in your vendor agreement.",
  legalTermsVendorPricingTitle: "Vendor pricing model",
  legalTermsVendorPricingP1: "MobiMart currently charges vendors a QAR 1,000 one-time setup fee, QAR 250 monthly subscription, and QAR 500 annual renewal fee. Vendors keep 100% of product sale proceeds for the introductory period; commission terms may change with 30 days' written notice.",
  legalTermsListingsTitle: "Listings & Content",
  legalTermsListingsP1: "Vendors are solely responsible for the accuracy of product listings, including descriptions, prices, photographs, condition (New, Like New, Good, Fair), and warranty claims. MobiMart does not pre-verify every listing but reserves the right to remove any listing that is inaccurate, misleading, prohibited, or in breach of these terms.",
  legalTermsOrdersTitle: "Orders & Payment",
  legalTermsOrdersP1: "An order is created when you click \"Place Order\". An order becomes binding once the vendor confirms acceptance.",
  legalTermsOrdersP2: "Accepted payment methods currently include:",
  legalTermsPayment1: "Cash on Delivery (COD) — payment in QAR to the courier on receipt of goods.",
  legalTermsPayment2: "Card payment — once Tap Payments integration is live, you will be able to pay by Visa, Mastercard, and other supported methods at checkout.",
  legalTermsOrdersP3: "All prices are listed in Qatari Riyal (QAR) and are inclusive of any applicable taxes unless stated otherwise.",
  legalTermsDeliveryTitle: "Delivery",
  legalTermsDeliveryP1: "We deliver across all of Qatar. Standard delivery is 1 to 3 business days from order confirmation. Shipping is free for orders above QAR 1,000 and QAR 15 flat for orders below that threshold. Full details are in our",
  legalTermsDeliveryShippingLink: "Shipping Policy",
  legalTermsDeliveryP2: "Risk of loss passes to the buyer when the carrier delivers the item to the address provided.",
  legalTermsReturnsTitle: "Returns & Refunds",
  legalTermsReturnsIntro: "Returns are accepted in two scenarios:",
  legalTermsReturns1: "Change of mind — within 24 hours of delivery, item must be unused and in original packaging.",
  legalTermsReturns2: "Defective, damaged, or wrong item — within 7 days of delivery.",
  legalTermsReturnsP1: "Refunds are processed within 7 to 14 business days. Full conditions are in our",
  legalTermsReturnsRefundLink: "Refund Policy",
  legalTermsProhibitedTitle: "Prohibited Conduct",
  legalTermsProhibitedIntro: "You may not use MobiMart to:",
  legalTermsProhibited1: "List or buy counterfeit, stolen, or recalled goods.",
  legalTermsProhibited2: "List items that infringe intellectual property rights of others.",
  legalTermsProhibited3: "Sell goods restricted under Qatari law without proper authorisation.",
  legalTermsProhibited4: "Engage in fraud, money laundering, or financing of illegal activity.",
  legalTermsProhibited5: "Harass, threaten, or abuse other users or MobiMart staff.",
  legalTermsProhibited6: "Attempt to bypass platform fees by directing transactions off-platform.",
  legalTermsProhibited7: "Scrape, copy, or republish MobiMart content without written permission.",
  legalTermsProhibited8: "Upload content that is unlawful, defamatory, obscene, or offensive to public morality.",
  legalTermsIPTitle: "Intellectual Property",
  legalTermsIPP1: "The MobiMart name, logo, design, and all platform code are the property of JASPR Trading Contracting and Services. Vendor content (product photos, descriptions) remains the property of the respective vendor; by listing on MobiMart, vendors grant us a non-exclusive licence to display this content on the platform and in marketing materials.",
  legalTermsLiabilityTitle: "Limitation of Liability",
  legalTermsLiabilityP1: "MobiMart provides the platform on an \"as is\" basis. We facilitate transactions between buyers and vendors but are not the seller of vendor-listed goods. Our liability for any claim arising from your use of MobiMart is limited to the value of the order in question.",
  legalTermsLiabilityP2: "Nothing in these terms limits any rights you have under the Qatar Consumer Protection Law (Law No. 8 of 2008) or other applicable Qatari law.",
  legalTermsTerminationTitle: "Termination",
  legalTermsTerminationP1: "You may close your account at any time by contacting customer support. We may suspend or terminate your account, with or without notice, if you breach these terms, engage in fraudulent activity, or if we are required to do so by law.",
  legalTermsLawTitle: "Governing Law",
  legalTermsLawP1: "These terms are governed by the laws of the State of Qatar. Any dispute arising out of or in connection with these terms is subject to the exclusive jurisdiction of the courts of Qatar.",
  legalTermsChangesTitle: "Changes to These Terms",
  legalTermsChangesP1: "We may update these terms from time to time. Material changes will be notified by email and through a notice on the platform at least 14 days before they take effect. Continued use of MobiMart after the effective date constitutes acceptance of the updated terms.",
  legalTermsContactTitle: "Contact",
  legalTermsContactP1: "For questions about these terms, please contact us at",
  legalTermsContactP2: "or call",
  legalTermsContactP3: "Customer support hours: Sunday to Thursday, 9 AM to 10 PM Qatar time. Full contact details are on our",
  legalTermsContactLink: "Contact page",
  legalPrivacyLede: "We respect your privacy. This policy explains what personal information we collect, why we collect it, how we use it, and the choices you have.",
  legalPrivacyTocWho: "Who We Are",
  legalPrivacyTocCollect: "What We Collect",
  legalPrivacyTocUse: "How We Use Your Information",
  legalPrivacyTocBasis: "Legal Basis for Processing",
  legalPrivacyTocSharing: "Sharing With Others",
  legalPrivacyTocIntl: "International Transfers",
  legalPrivacyTocRetention: "Retention",
  legalPrivacyTocRights: "Your Rights",
  legalPrivacyTocCookies: "Cookies & Tracking",
  legalPrivacyTocSecurity: "Security",
  legalPrivacyTocChildren: "Children",
  legalPrivacyTocChanges: "Changes",
  legalPrivacyTocContact: "Contact",
  legalPrivacyWhoTitle: "Who We Are",
  legalPrivacyWhoP1: "MobiMart is operated by JASPR Trading Contracting and Services, a company registered in the State of Qatar (Commercial Registration CR-223480), with offices at Building 43, Street 310, Zone 27, Doha, Qatar.",
  legalPrivacyWhoP2: "We are the data controller for personal information processed through MobiMart. If you have any questions about how we handle your data, contact us at support@jasprmarket.com.",
  legalPrivacyCollectTitle: "What We Collect",
  legalPrivacyCollectIntro: "We collect personal information in three broad categories:",
  legalPrivacyCollectGiveTitle: "Information you give us",
  legalPrivacyCollectGive1: "Account details: name, email, phone number, password (stored encrypted).",
  legalPrivacyCollectGive2: "Delivery details: shipping address, alternate phone numbers if provided.",
  legalPrivacyCollectGive3: "Vendor details: if you register as a vendor — store name, Commercial Registration number, identification documents (KYC), banking details (IBAN), business license documents.",
  legalPrivacyCollectGive4: "Communications: messages you send to customer support, vendor messages, order notes.",
  legalPrivacyCollectGive5: "Reviews: ratings, written reviews, and the products you reviewed.",
  legalPrivacyCollectTransTitle: "Information from your transactions",
  legalPrivacyCollectTrans1: "Order history, items purchased, prices paid, delivery status.",
  legalPrivacyCollectTrans2: "Payment information — processed by our payment provider; we do not store full card numbers.",
  legalPrivacyCollectTrans3: "Refund and return requests.",
  legalPrivacyCollectAutoTitle: "Information we collect automatically",
  legalPrivacyCollectAuto1: "Device & connection: IP address, browser type, device type, operating system.",
  legalPrivacyCollectAuto2: "Usage data: pages viewed, products clicked, time spent, referral source.",
  legalPrivacyCollectAuto3: "Cookies & similar technologies: see Section 9 below.",
  legalPrivacyUseTitle: "How We Use Your Information",
  legalPrivacyUseIntro: "We use your information to:",
  legalPrivacyUse1: "Create and manage your account.",
  legalPrivacyUse2: "Process orders, payments, deliveries, and refunds.",
  legalPrivacyUse3: "Communicate with you about orders (invoices, status updates, dispatch notifications).",
  legalPrivacyUse4: "Verify vendor identity and KYC compliance.",
  legalPrivacyUse5: "Provide customer support.",
  legalPrivacyUse6: "Detect and prevent fraud or abuse.",
  legalPrivacyUse7: "Improve the platform — understand which products and features are popular.",
  legalPrivacyUse8: "Comply with our legal obligations under Qatari law.",
  legalPrivacyUse9: "Send marketing communications, where you have consented (you can unsubscribe at any time).",
  legalPrivacyBasisTitle: "Legal Basis for Processing",
  legalPrivacyBasisIntro: "We process your information on one or more of these legal bases:",
  legalPrivacyBasis1: "Contractual necessity — to fulfil orders and provide the services you've requested.",
  legalPrivacyBasis2: "Legitimate interests — to operate the platform securely, prevent fraud, and improve our services.",
  legalPrivacyBasis3: "Legal obligation — to comply with Qatari laws including tax, e-commerce licensing, and consumer protection requirements.",
  legalPrivacyBasis4: "Consent — for marketing communications and any optional analytics cookies.",
  legalPrivacySharingTitle: "Sharing With Others",
  legalPrivacySharingIntro: "We share your information only as needed to operate MobiMart, and only with parties who are contractually bound to protect your data:",
  legalPrivacySharingColRecipient: "Recipient",
  legalPrivacySharingColShare: "What we share",
  legalPrivacySharingColWhy: "Why",
  legalPrivacySharingVendorsName: "Vendors",
  legalPrivacySharingVendorsShare: "Your name, delivery address, phone, order details",
  legalPrivacySharingVendorsWhy: "To pack and dispatch your order",
  legalPrivacySharingCloudinaryShare: "Product and document images you upload",
  legalPrivacySharingCloudinaryWhy: "Cloud image storage (US-based)",
  legalPrivacySharingResendShare: "Email address, name, order details for transactional emails",
  legalPrivacySharingResendWhy: "Email delivery service (EU-based, Ireland)",
  legalPrivacySharingTapShare: "Name, email, payment details (when integrated)",
  legalPrivacySharingTapWhy: "Process card payments (regulated in Qatar/MENA)",
  legalPrivacySharingCouriersName: "Couriers & delivery partners",
  legalPrivacySharingCouriersShare: "Name, delivery address, phone",
  legalPrivacySharingCouriersWhy: "Deliver your order",
  legalPrivacySharingGovName: "Government authorities",
  legalPrivacySharingGovShare: "As legally required",
  legalPrivacySharingGovWhy: "Compliance with Qatari law",
  legalPrivacySharingNoSell: "We do not sell your personal information to advertisers or data brokers.",
  legalPrivacyIntlTitle: "International Transfers",
  legalPrivacyIntlP1: "Some of our service providers (Cloudinary, Resend) operate servers outside Qatar. When your data is transferred internationally, we ensure appropriate contractual safeguards are in place. Resend's sending region for MobiMart is configured to Ireland (eu-west-1), which provides EU-equivalent data protection standards.",
  legalPrivacyRetentionTitle: "Retention",
  legalPrivacyRetentionIntro: "We keep your information only as long as needed:",
  legalPrivacyRetention1: "Account data: while your account is active, plus 90 days after closure (for support queries).",
  legalPrivacyRetention2: "Order records: 7 years (as required by Qatar tax and commercial law).",
  legalPrivacyRetention3: "Vendor KYC documents: for the duration of the vendor relationship plus 7 years.",
  legalPrivacyRetention4: "Marketing data: until you unsubscribe.",
  legalPrivacyRetention5: "Server logs: 30 days, unless retention is required for security investigations.",
  legalPrivacyRightsTitle: "Your Rights",
  legalPrivacyRightsIntro: "You have the right to:",
  legalPrivacyRights1: "Access — request a copy of the personal information we hold about you.",
  legalPrivacyRights2: "Correct — update inaccurate information.",
  legalPrivacyRights3: "Delete — request deletion of your account and personal data, subject to legal retention requirements.",
  legalPrivacyRights4: "Object — opt out of marketing communications and ask us to stop processing for marketing purposes.",
  legalPrivacyRights5: "Portability — receive your data in a structured, machine-readable format.",
  legalPrivacyRights6: "Withdraw consent — for processing based on consent, at any time.",
  legalPrivacyRightsContact: "To exercise any of these rights, email",
  legalPrivacyRightsResponse: "We will respond within 30 days.",
  legalPrivacyCookiesTitle: "Cookies & Tracking",
  legalPrivacyCookiesIntro: "MobiMart uses cookies and similar technologies to make the platform work. We use:",
  legalPrivacyCookies1: "Essential cookies — for login sessions, shopping cart contents, and security. These cannot be turned off as they are needed for the platform to function.",
  legalPrivacyCookies2: "Functional cookies — to remember your language preference (English / Arabic) and other settings.",
  legalPrivacyCookiesFuture: "If we add analytics or marketing tracking in the future, we will update this policy and request your consent through a cookie banner before any non-essential cookies are set.",
  legalPrivacySecurityTitle: "Security",
  legalPrivacySecurityIntro: "We protect your data using:",
  legalPrivacySecurity1: "HTTPS encryption for all traffic between your browser and our servers.",
  legalPrivacySecurity2: "Encrypted password storage (industry-standard hashing).",
  legalPrivacySecurity3: "Restricted internal access to personal data on a need-to-know basis.",
  legalPrivacySecurity4: "Regular security reviews of third-party services we integrate with.",
  legalPrivacySecurity5: "Authentication tokens (JWT) with secure expiration policies.",
  legalPrivacySecurityBreach: "No system is perfectly secure. If we ever discover a personal data breach affecting you, we will notify you and the relevant authorities promptly, as required by Qatari law.",
  legalPrivacyChildrenTitle: "Children",
  legalPrivacyChildrenP1: "MobiMart is not intended for users under 18. We do not knowingly collect personal information from children. If you believe a child has provided us with personal information, please contact us at",
  legalPrivacyChildrenP2: "and we will delete it promptly.",
  legalPrivacyChangesTitle: "Changes",
  legalPrivacyChangesP1: "We may update this Privacy Policy from time to time. Material changes will be notified by email and posted on the platform at least 14 days before they take effect. The \"Effective\" date at the top of this page tells you when the current version began.",
  legalPrivacyContactTitle: "Contact",
  legalPrivacyContactP1: "Privacy questions or requests:",
  legalPrivacyContactP2: "Phone:",
  legalPrivacyContactP3: "Mail:",
  legalPrivacyNoticeTitle: "Important:",
  legalPrivacyNoticeText: "This summary highlights key points. Please read the full policy below for complete details on how your information is collected, used, and protected.",
  legalRefundTocCOD: "Cash on Delivery Orders",
  legalRefundMethodChangeMindPay: "Change of mind",
  legalRefundMethodChangeMindMethod: "Store credit or original payment method",
  legalRefundMethodChangeMindTime: "5-7 business days after approval",
  legalRefundCancelP3: "Once an order has been dispatched for delivery, it can no longer be cancelled and must instead follow the standard return process.",
  legalRefundCODTitle: "Cash on Delivery (COD) orders",
  legalRefundCODP1: "For orders paid by Cash on Delivery, refunds for approved returns are issued as store credit or through bank transfer, as full payment was not processed electronically at the time of order.",
  legalRefundWarrantyP3: "Warranty claims are handled directly between the customer and the vendor or manufacturer, in accordance with the specific warranty terms provided at the time of purchase.",
  legalShippingTocForceMajeure: "Force Majeure",
  legalShippingForceMajeureTitle: "Force majeure",
  legalShippingForceMajeureP1: "MobiMart shall not be held liable for delivery delays or failures caused by events beyond its reasonable control, including but not limited to natural disasters, government restrictions, strikes, or other circumstances constituting force majeure.",


// ── Shared across all pages ────────────────────────────────────────────
  legalEffective: 'Effective',
  legalVersion: 'Version',
  legalContents: 'Contents',

  legalFooterOperator: 'Operator',
  legalFooterCare: 'Customer Care',
  legalFooterLegal: 'Legal',
  legalFooterHours: 'Sun–Thu, 9 AM – 10 PM',
  legalFooterTerms: 'Terms of Service',
  legalFooterPrivacy: 'Privacy Policy',
  legalFooterRefund: 'Refund Policy',
  legalFooterShipping: 'Shipping Policy',
  legalFooterCRLine1: 'Commercial Registration:',
  legalFooterCRLine2: 'E-Commerce Licence:',
  legalFooterPending: 'pending',
  legalFooterRights: 'All rights reserved.',


// Terms & Conditions — JASPR Trading / MobiMart
legalTermsTitle: 'Terms & Conditions',
legalTermsLede: '...',
legalPrivacyTitle: 'Privacy Policy',


  // ── REFUND POLICY ──────────────────────────────────────────────────────
  legalRefundTitle: 'Refund & Return Policy',
  legalRefundLede: 'We want you to shop with confidence. This policy explains when you can return an item, how the process works, and how long refunds take.',
  legalRefundQuickSummary: 'Quick summary:',
  legalRefundQuickText: 'Change of mind? Return within 24 hours of delivery. Item defective, damaged, or wrong product? Return within 7 days. Refunds processed in 7–14 business days.',

  legalRefundTocWhen: 'When You Can Return an Item',
  legalRefundTocConditions: 'Condition Requirements',
  legalRefundTocNonReturn: 'Non-Returnable Items',
  legalRefundTocHow: 'How to Return',
  legalRefundTocMethod: 'Refund Method & Timing',
  legalRefundTocShipping: 'Return Shipping Cost',
  legalRefundTocCancel: 'Order Cancellations',
  legalRefundTocWarranty: 'Warranty Claims',
  legalRefundTocDisputes: 'Disputes',
  legalRefundTocContact: 'Contact',

  legalRefundWhenTitle: 'When You Can Return an Item',
  legalRefundWhenIntro: 'MobiMart accepts returns in two situations:',
  legalRefundChangeMindTitle: 'Change of mind',
  legalRefundChangeMindIntro: 'If you change your mind about a purchase, you may return it within 24 hours of delivery. The item must be:',
  legalRefundChangeMind1: 'Unused, in the same condition as received.',
  legalRefundChangeMind2: 'In the original packaging, including all accessories, manuals, and tags.',
  legalRefundChangeMind3: 'Returned with the original invoice or order number.',
  legalRefundDefectiveTitle: 'Defective, damaged, or wrong item',
  legalRefundDefectiveIntro: 'If the item arrives defective, damaged, or different from what was ordered, you may return it within 7 days of delivery. We will arrange the return at no cost to you, and you may choose:',
  legalRefundDefective1: 'A full refund, or',
  legalRefundDefective2: 'A replacement item (subject to availability), or',
  legalRefundDefective3: 'Repair, where applicable.',
  legalRefundDefectiveLaw: 'This right is in addition to any rights you have under the Qatar Consumer Protection Law (Law No. 8 of 2008).',

  legalRefundConditionsTitle: 'Condition Requirements',
  legalRefundConditionsIntro: 'For a return to be accepted, the item must be:',
  legalRefundConditions1: 'In the same condition as when delivered (unused for change-of-mind returns).',
  legalRefundConditions2: 'Accompanied by the original packaging, accessories, manuals, and any free gifts.',
  legalRefundConditions3: 'Reported through our customer support channel (not directly to vendors).',
  legalRefundConditionsP1: 'Items returned without their original packaging, with missing accessories, or showing signs of use beyond inspection may receive a partial refund or be refused.',

  legalRefundNonReturnTitle: 'Non-Returnable Items',
  legalRefundNonReturnIntro: 'For hygiene, safety, and product-specific reasons, the following items cannot be returned unless they are defective on arrival:',
  legalRefundNonReturn1: 'In-ear headphones, earbuds, and personal audio devices once unsealed.',
  legalRefundNonReturn2: 'Screen protectors that have been applied.',
  legalRefundNonReturn3: 'SIM cards, prepaid cards, and digital codes once activated.',
  legalRefundNonReturn4: 'Items marked "Final Sale" or "Clearance" on the product page.',
  legalRefundNonReturn5: 'Custom-ordered or personalised items.',

  legalRefundHowTitle: 'How to Return',
  legalRefundHow1Title: 'Contact us within the eligibility window. Email',
  legalRefundHow1Body: 'or call +974 6614 2417 with your order number, the reason for return, and a photograph if the item is damaged.',
  legalRefundHow2: 'Wait for confirmation. Our team will review the request within 1 business day and email you instructions and a return reference number.',
  legalRefundHow3: 'Pack the item securely with all original packaging and accessories.',
  legalRefundHow4: 'Hand the parcel to our designated courier when they collect (we will arrange this).',
  legalRefundHow5: 'Track the refund. Once the item arrives back and passes inspection, we begin the refund process.',

  legalRefundMethodTitle: 'Refund Method & Timing',
  legalRefundMethodIntro: 'Refunds are issued to the same payment method used for the original purchase:',
  legalRefundMethodColPay: 'Original payment method',
  legalRefundMethodColMethod: 'Refund method',
  legalRefundMethodColTime: 'Timeline',
  legalRefundMethodCODPay: 'Cash on Delivery (COD)',
  legalRefundMethodCODMethod: 'Bank transfer to your nominated account',
  legalRefundMethodCODTime: '7–14 business days after item received',
  legalRefundMethodCardPay: 'Credit / Debit card (when available)',
  legalRefundMethodCardMethod: 'Reversal to the original card',
  legalRefundMethodCardTime: '7–14 business days; some banks may take longer',
  legalRefundMethodWindow: 'The 7–14 business day window starts the day after the returned item is received and inspected at our facility. We will email you a confirmation when the refund is initiated.',

  legalRefundShippingTitle: 'Return Shipping Cost',
  legalRefundShipping1: 'Defective, damaged, or wrong items: we cover the cost of return shipping.',
  legalRefundShipping2: 'Change of mind: the customer is responsible for return shipping (typically QAR 15) — this amount is deducted from the refund.',
  legalRefundShippingP1: 'If your original order qualified for free shipping (orders above QAR 1,000) and a partial return brings the order below the free shipping threshold, the original shipping cost (QAR 15) may be deducted from the refund.',

  legalRefundCancelTitle: 'Order Cancellations',
  legalRefundCancelP1: 'You may cancel an order at no cost before it is dispatched. Once the vendor has handed the parcel to our courier, the cancellation becomes a return — please follow the return process described above.',
  legalRefundCancelP2: 'To cancel, log into your account and select "Cancel Order" on the order details page, or contact customer support immediately at',

  legalRefundWarrantyTitle: 'Warranty Claims',
  legalRefundWarrantyP1: 'Many products on MobiMart come with a manufacturer\'s warranty (typically 6 to 12 months for new mobile phones). Warranty terms are set by the manufacturer or vendor, not MobiMart, and are stated on each product page.',
  legalRefundWarrantyP2: 'For warranty claims after the 7-day return window, contact the manufacturer\'s authorised service centre in Qatar. If you need help locating the service centre, our customer support team can assist.',

  legalRefundDisputesTitle: 'Disputes',
  legalRefundDisputesP1: 'If you are unhappy with the outcome of a return or refund request, please escalate to',
  legalRefundDisputesP2: 'with the subject line "ESCALATION" and the original ticket reference. We will review your case within 7 business days.',
  legalRefundDisputesP3: 'If the matter is still unresolved, you may file a complaint with the Consumer Protection Department at the Qatar Ministry of Commerce and Industry. Their hotline is',
  legalRefundDisputesP4: ', or visit the MoCI website for the online complaint form. Nothing in this policy affects your rights under the Qatar Consumer Protection Law.',

  legalRefundContactTitle: 'Contact',
  legalRefundContactP1: 'For all return or refund queries: Email',
  legalRefundContactP2: 'Phone',
  legalRefundContactP3: 'Hours: Sunday to Thursday, 9 AM to 10 PM Qatar time',

  // ── SHIPPING POLICY ────────────────────────────────────────────────────
  legalShippingTitle: 'Shipping & Delivery Policy',
  legalShippingLede: 'We deliver across Qatar in 1–3 business days. Free shipping on orders above QAR 1,000.',
  legalShippingGlance: 'At a glance:',
  legalShippingGlanceText: 'All of Qatar covered. 1–3 business days. Free shipping for orders above QAR 1,000, otherwise QAR 15 flat. Cash on Delivery accepted.',

  legalShippingTocCoverage: 'Coverage Area',
  legalShippingTocTiming: 'Delivery Times',
  legalShippingTocCost: 'Shipping Cost',
  legalShippingTocProcessing: 'Order Processing',
  legalShippingTocTracking: 'Tracking',
  legalShippingTocReceiving: 'Receiving Your Order',
  legalShippingTocFailed: 'Failed Deliveries',
  legalShippingTocAddress: 'Address Changes',
  legalShippingTocContact: 'Contact',

  legalShippingCoverageTitle: 'Coverage Area',
  legalShippingCoverageIntro: 'MobiMart delivers to all of Qatar, including:',
  legalShippingCoverage1: 'Doha and all metropolitan municipalities',
  legalShippingCoverage2: 'Al Wakrah, Al Khor, Al Daayen, Al Rayyan, Umm Salal',
  legalShippingCoverage3: 'Al Shahaniya, Al Shamal, Al Sheehaniya',
  legalShippingCoverage4: 'Mesaieed, Dukhan, and outlying residential areas',
  legalShippingCoverageRemote: 'Some remote areas may have slightly extended delivery times. If our courier is unable to reach a delivery address, customer support will contact you to arrange an alternative.',
  legalShippingCoverageNoIntl: 'We do not currently ship outside Qatar.',

  legalShippingTimingTitle: 'Delivery Times',
  legalShippingTimingIntro: 'Standard delivery: 1 to 3 business days from order confirmation.',
  legalShippingTimingColPlaced: 'Order placed',
  legalShippingTimingColExpected: 'Expected delivery',
  legalShippingTimingSunWedPlaced: 'Sunday – Wednesday',
  legalShippingTimingSunWedExpected: 'Within 1–3 business days',
  legalShippingTimingThuPlaced: 'Thursday after 2 PM',
  legalShippingTimingThuExpected: 'From Sunday onwards',
  legalShippingTimingFriSatPlaced: 'Friday – Saturday',
  legalShippingTimingFriSatExpected: 'From Sunday onwards',
  legalShippingTimingBusiness: 'Business days are Sunday through Thursday, excluding public holidays in Qatar. Our courier partners do not deliver on Fridays or public holidays.',
  legalShippingTimingPeak: 'Delivery may take longer during peak seasons (Eid, Ramadan, Qatar National Day) or in rare circumstances such as severe weather. We will notify you if your order is delayed.',

  legalShippingCostTitle: 'Shipping Cost',
  legalShippingCostColValue: 'Order value',
  legalShippingCostColCost: 'Shipping cost',
  legalShippingCostAbove: 'Above QAR 1,000',
  legalShippingCostAboveValue: 'Free',
  legalShippingCostBelow: 'QAR 1,000 or below',
  legalShippingCostBelowValue: 'QAR 15 flat',
  legalShippingCostP1: 'Shipping cost is calculated at checkout based on your cart subtotal and is shown clearly before you place the order. There are no hidden fees.',

  legalShippingProcessingTitle: 'Order Processing',
  legalShippingProcessingIntro: 'Once you place an order:',
  legalShippingProcessing1: 'You receive an immediate order confirmation email.',
  legalShippingProcessing2: 'The vendor receives a dispatch notification and prepares the item.',
  legalShippingProcessing3: 'The vendor hands the parcel to our courier (typically within 1 business day).',
  legalShippingProcessing4: 'You receive a status update by email each time the order moves.',
  legalShippingProcessing5: 'The courier delivers to your address.',

  legalShippingTrackingTitle: 'Tracking',
  legalShippingTrackingP1: 'Order status is updated in your MobiMart account in real time. You can view current status by logging in and going to My Orders. Status emails are also sent at each major step:',
  legalShippingTracking1: 'Pending — order placed, awaiting vendor confirmation.',
  legalShippingTracking2: 'Confirmed — vendor has accepted and is preparing the item.',
  legalShippingTracking3: 'Shipped — courier has collected the parcel.',
  legalShippingTracking4: 'Delivered — order has been received.',

  legalShippingReceivingTitle: 'Receiving Your Order',
  legalShippingReceivingIntro: 'When your order arrives:',
  legalShippingReceiving1: 'Inspect the package before signing for it. Note any visible damage to the box on the courier\'s delivery sheet.',
  legalShippingReceiving2: 'For Cash on Delivery orders, please have the exact amount in QAR ready to give to the courier.',
  legalShippingReceiving3: 'You may need to show identification to confirm receipt of high-value items.',
  legalShippingReceivingIssue: 'If something is wrong with the order — wrong item, damaged in transit, missing accessories — please follow the steps in our',
  legalShippingReceivingRefund: 'Refund Policy',
  legalShippingReceivingIssue2: ' within 7 days of delivery.',

  legalShippingFailedTitle: 'Failed Deliveries',
  legalShippingFailedIntro: 'If our courier is unable to deliver because no one is available, the address is incorrect, or the area is inaccessible, they will:',
  legalShippingFailed1: 'Attempt redelivery the following business day.',
  legalShippingFailed2: 'Contact you on the phone number provided.',
  legalShippingFailed3: 'After two failed attempts, return the parcel to our facility.',
  legalShippingFailedP1: 'If the order is returned to us as undeliverable, customer support will contact you to arrange a new delivery (additional shipping cost may apply) or a refund.',

  legalShippingAddressTitle: 'Address Changes',
  legalShippingAddressP1: 'You can change the delivery address while the order is still in Pending status. Once the order moves to Confirmed or Shipped, address changes may not be possible — please contact customer support as soon as you can and we will do our best.',

  legalShippingContactTitle: 'Contact',
  legalShippingContactP1: 'For shipping or delivery enquiries: Email',
  legalShippingContactP2: 'Phone',
  legalShippingContactP3: 'Hours: Sunday to Thursday, 9 AM to 10 PM Qatar time',

  // ── CONTACT US ─────────────────────────────────────────────────────────
  legalContactMetaCare: 'Customer Care',
  legalContactTitle: 'Contact Us',
  legalContactLede: 'We\'re here to help. Whether you have a question about an order, want to become a vendor, or need help with returns — these are the fastest ways to reach us.',

  legalContactCardEmail: 'Email',
  legalContactCardEmailNote: 'Replies within 1 business day.',
  legalContactCardPhone: 'Phone',
  legalContactCardPhoneNote: 'Sun–Thu, 9 AM – 10 PM Qatar time.',
  legalContactCardAddress: 'Address',
  legalContactCardAddressLine1: 'Building 43, Street 310, Zone 27',
  legalContactCardAddressLine2: 'Doha, State of Qatar',
  legalContactCardAddressNote: 'Visits by appointment only.',

  legalContactWhoTitle: 'Who to Contact for What',
  legalContactWhoIntro: 'Save yourself some time — write to the right place and we\'ll get back faster.',
  legalContactWhoColAbout: 'Your question is about…',
  legalContactWhoColEmail: 'Email this address',
  legalContactWhoOrders: 'Order status, delivery, payments',
  legalContactWhoSupport: 'Returns, refunds, complaints',
  legalContactWhoSales: 'Becoming a vendor / store registration',
  legalContactWhoInfo: 'General enquiries, partnership, press',
  legalContactWhoPrivacy: 'Privacy, data requests, account deletion',

  legalContactHoursTitle: 'Customer Support Hours',
  legalContactHoursIntro: 'Our team responds to phone and email between:',
  legalContactHours1: 'Sunday – Thursday: 9:00 AM to 10:00 PM Qatar time (GMT+3)',
  legalContactHours2: 'Friday – Saturday: Closed (emails received on these days are answered first thing on Sunday)',
  legalContactHours3: 'Public holidays: Closed',
  legalContactHoursUrgent: 'For urgent delivery issues outside support hours, please email — we monitor for emergencies.',

  legalContactResponseTitle: 'Response Times',
  legalContactResponse1: 'Email: first response within 1 business day; resolution typically within 2–3 business days.',
  legalContactResponse2: 'Phone: answered live during support hours.',
  legalContactResponse3: 'Refund requests: reviewed within 1 business day of receipt.',
  legalContactResponse4: 'Vendor approval: within 24 hours of all required KYC documents being submitted.',

  legalContactVendorsTitle: 'For Vendors',
  legalContactVendorsP1: 'Already a MobiMart vendor? Log into your Vendor Dashboard for direct access to support, sales reports, and dispatch tools.',
  legalContactVendorsP2: 'Want to sell on MobiMart? We onboard new vendors regularly. Email',
  legalContactVendorsP3: 'with:',
  legalContactVendors1: 'Your business name and Commercial Registration number',
  legalContactVendors2: 'Categories you sell in',
  legalContactVendors3: 'Estimated monthly volume',
  legalContactVendors4: 'A contact name and phone number',
  legalContactVendorsPricing: 'Vendor pricing: QAR 1,000 setup fee, QAR 250 monthly subscription, QAR 500 annual renewal.',

  legalContactComplaintsTitle: 'Complaints & Escalation',
  legalContactComplaintsP1: 'If you\'ve contacted us and feel your issue isn\'t being resolved, please email',
  legalContactComplaintsP2: 'with the subject line "ESCALATION" and the original ticket reference. A senior team member will review within 3 business days.',
  legalContactComplaintsP3: 'If after escalation the matter is still unresolved, you have the right to file a complaint with the Consumer Protection Department of the Qatar Ministry of Commerce and Industry, hotline',
  legalContactComplaintsP4: ', or via the MoCI website.',

  legalContactCompanyTitle: 'Company Details',
  legalContactCompanyP1: 'MobiMart is operated by:',
  legalContactCompanyCR: 'Commercial Registration:',
  legalContactCompanyAddr: 'Address:',
  legalContactCompanyPhone: 'Phone:',
  legalContactCompanyWeb: 'Web:',
}

const legalAR = {
  legalEffective: 'ساري المفعول',
  legalVersion: 'الإصدار',
  legalContents: 'المحتويات',

  legalFooterOperator: 'المشغل',
  legalFooterCare: 'خدمة العملاء',
  legalFooterLegal: 'القانونية',
  legalFooterHours: 'الأحد–الخميس، 9 صباحاً – 10 مساءً',
  legalFooterTerms: 'الشروط والأحكام',
  legalFooterPrivacy: 'سياسة الخصوصية',
  legalFooterRefund: 'سياسة الاسترجاع والاسترداد',
  legalFooterShipping: 'سياسة الشحن والتوصيل',
  legalFooterCRLine1: 'السجل التجاري:',
  legalFooterCRLine2: 'رخصة التجارة الإلكترونية:',
  legalFooterPending: 'قيد الإصدار',
  legalFooterRights: 'جميع الحقوق محفوظة.',

  // ── TERMS OF SERVICE ───────────────────────────────────────────────────
  legalTermsTitle: 'الشروط والأحكام',
  legalTermsLede: 'تنظم هذه الشروط والأحكام الوصول إلى واستخدام منصة موبي مارت التي تديرها شركة جاسبر للتجارة والمقاولات والخدمات في دولة قطر.',

  legalTermsTocAbout: 'نبذة عن موبي مارت',
  legalTermsTocAccounts: 'الحسابات والأهلية',
  legalTermsTocBuyers: 'المشترون',
  legalTermsTocVendors: 'البائعون',
  legalTermsTocListings: 'القوائم والمحتوى',
  legalTermsTocOrders: 'الطلبات والدفع',
  legalTermsTocDelivery: 'التوصيل',
  legalTermsTocReturns: 'الاسترجاع والاسترداد',
  legalTermsTocProhibited: 'المنتجات والسلوكيات المحظورة',
  legalTermsTocIP: 'الملكية الفكرية',
  legalTermsTocLiability: 'حدود المسؤولية',
  legalTermsTocTermination: 'إنهاء الخدمة',
  legalTermsTocLaw: 'القانون الواجب التطبيق',
  legalTermsTocChanges: 'التعديلات على هذه الشروط',
  legalTermsTocContact: 'التواصل',

  legalTermsAboutTitle: 'نبذة عن موبي مارت',
  legalTermsAboutP1: 'موبي مارت هي منصة سوق إلكتروني تديرها شركة جاسبر للتجارة والمقاولات والخدمات، السجل التجاري CR-223480، ومقرها في الدوحة، دولة قطر.',
  legalTermsAboutP2: 'تتيح موبي مارت للبائعين والتجار المستقلين عرض وبيع المنتجات والخدمات للعملاء داخل دولة قطر. وما لم يذكر خلاف ذلك صراحة، فإن موبي مارت تعمل كمنصة وسيطة وليست البائع المباشر للمنتجات المعروضة من قبل البائعين الخارجيين.',

  legalTermsAccountsTitle: 'الحسابات والأهلية',
  legalTermsAccountsP1: 'لاستخدام موبي مارت، يجب على المستخدمين تقديم معلومات صحيحة والحفاظ على سرية الحساب واستخدام المنصة بشكل قانوني.',
  legalTermsEligibilityTitle: 'الأهلية',
  legalTermsEligibility1: 'يجب ألا يقل عمر المستخدم عن 18 عاماً أو أن يستخدم المنصة تحت إشراف ولي الأمر أو الوصي القانوني.',
  legalTermsEligibility2: 'يجب على المستخدم تقديم رقم هاتف محمول وبريد إلكتروني ومعلومات حساب صحيحة.',
  legalTermsEligibility3: 'قد تتطلب حسابات البائعين تقديم بيانات السجل التجاري ومستندات الهوية والمعلومات البنكية.',
  legalTermsAccountsP2: 'يجوز لموبي مارت تعليق أو إنهاء الحسابات التي تقدم معلومات غير صحيحة أو تخالف هذه الشروط أو تسيء استخدام المنصة أو تشارك في نشاط احتيالي.',

  legalTermsBuyersTitle: 'المشترون',
  legalTermsBuyersIntro: 'بصفتك مشترياً، فإنك توافق على ما يلي:',
  legalTermsBuyers1: 'تقديم بيانات توصيل وتواصل صحيحة.',
  legalTermsBuyers2: 'دفع كامل قيمة الطلب باستخدام وسائل الدفع المتاحة على المنصة.',
  legalTermsBuyers3: 'فحص المنتجات عند الاستلام والإبلاغ عن أي مشكلة خلال المدة المحددة في سياسة الاسترجاع والاسترداد.',
  legalTermsBuyers4: 'استخدام المنصة بشكل قانوني والتعامل باحترام مع البائعين وممثلي خدمة العملاء.',

  legalTermsVendorsTitle: 'البائعون',
  legalTermsVendorsIntro: 'يدير البائعون أعمالهم بشكل مستقل ويستخدمون موبي مارت كمنصة سوق إلكتروني للوصول إلى العملاء. وبصفتك بائعاً، فإنك توافق على ما يلي:',
  legalTermsVendors1: 'امتلاك التسجيلات والتراخيص القانونية المطلوبة بموجب قوانين دولة قطر.',
  legalTermsVendors2: 'تقديم مستندات التحقق من الهوية والأعمال المطلوبة.',
  legalTermsVendors3: 'عرض المنتجات القانونية والأصلية والمصرح بها فقط.',
  legalTermsVendors4: 'تقديم أوصاف وصور وأسعار وحالة مخزون ومعلومات ضمان دقيقة للمنتجات.',
  legalTermsVendors5: 'الالتزام بمتطلبات التوصيل والتغليف والاسترجاع والاسترداد وخدمة العملاء.',
  legalTermsVendors6: 'تجهيز وشحن الطلبات ضمن الإطار الزمني المتفق عليه.',
  legalTermsVendors7: 'تحمل المسؤولية عن جودة المنتجات ومشروعيتها وأصالتها وضماناتها والتزامات ما بعد البيع.',
  legalTermsVendors8: 'دفع رسوم المنصة المطبقة حسب الاتفاق مع موبي مارت.',
  legalTermsVendorPricingTitle: 'نموذج تسعير البائعين',
  legalTermsVendorPricingP1: 'تفرض موبي مارت حالياً على البائعين رسوم تسجيل أو إعداد قدرها 1000 ريال قطري، واشتراكاً شهرياً قدره 250 ريال قطري، ورسوم تجديد سنوية قدرها 500 ريال قطري. ويجوز لموبي مارت تحديث رسوم البائعين أو شروط العمولة بعد تقديم إشعار مسبق معقول.',

  legalTermsListingsTitle: 'القوائم والمحتوى',
  legalTermsListingsP1: 'يتحمل البائعون وحدهم مسؤولية دقة ومشروعية الأسعار والأوصاف والصور وحالة المنتج ومطالبات الضمان وتوفر جميع المنتجات المعروضة. ويجوز لموبي مارت إزالة أي قائمة تكون غير دقيقة أو مضللة أو محظورة أو غير قانونية أو مخالفة لهذه الشروط.',

  legalTermsOrdersTitle: 'الطلبات والدفع',
  legalTermsOrdersP1: 'يتم إنشاء الطلب عندما يقوم العميل بتقديم طلب عبر المنصة. وتظل الطلبات خاضعة لتوفر المنتج وقبول البائع ونجاح تفويض الدفع وفحوصات منع الاحتيال.',
  legalTermsOrdersP2: 'قد تشمل وسائل الدفع المقبولة ما يلي:',
  legalTermsPayment1: 'الدفع عند الاستلام، حيثما كان متاحاً.',
  legalTermsPayment2: 'وسائل الدفع الإلكتروني مثل البطاقات أو بوابات الدفع المعتمدة عند تفعيلها.',
  legalTermsOrdersP3: 'تعرض جميع الأسعار بالريال القطري. وقد تشمل الأسعار أو لا تشمل الضرائب أو الرسوم أو التكاليف المطبقة حسب ما يتم توضيحه أثناء الدفع.',

  legalTermsDeliveryTitle: 'التوصيل',
  legalTermsDeliveryP1: 'تخضع خدمات التوصيل لسياسة الشحن والتوصيل المنشورة على المنصة.',
  legalTermsDeliveryShippingLink: 'سياسة الشحن والتوصيل',
  legalTermsDeliveryP2: 'تعتبر مواعيد التوصيل تقديرية فقط وقد تختلف بسبب وقت تجهيز البائع أو توفر شركة التوصيل أو الأحوال الجوية أو العطلات الرسمية أو الازدحام المروري أو أي أحداث خارجة عن السيطرة المعقولة لموبي مارت.',

  legalTermsReturnsTitle: 'الاسترجاع والاسترداد',
  legalTermsReturnsIntro: 'تخضع عمليات الاسترجاع والاسترداد لسياسة الاسترجاع والاسترداد المنشورة على المنصة.',
  legalTermsReturns1: 'قد يتم قبول الاسترجاع بسبب تغيير الرأي خلال المدة المحددة إذا كان المنتج غير مستخدم وبحالته الأصلية.',
  legalTermsReturns2: 'قد تكون المنتجات المعيبة أو التالفة أو الخاطئة أو المختلفة جوهرياً مؤهلة للاسترجاع أو الاستبدال أو الإصلاح أو الاسترداد وفقاً للقانون المعمول به وسياسة المنصة.',
  legalTermsReturnsP1: 'يرجى قراءة',
  legalTermsReturnsRefundLink: 'سياسة الاسترجاع والاسترداد',

  legalTermsProhibitedTitle: 'المنتجات والسلوكيات المحظورة',
  legalTermsProhibitedIntro: 'لا يجوز للمستخدمين أو البائعين استخدام موبي مارت لعرض أو بيع أو شراء أو توزيع أو الترويج لأي منتجات محظورة أو أنشطة غير قانونية، بما في ذلك:',
  legalTermsProhibited1: 'المنتجات المقلدة أو المسروقة أو المسحوبة أو المنتجات ذات العلامات التجارية غير المصرح بها.',
  legalTermsProhibited2: 'المنتجات التي تنتهك حقوق الملكية الفكرية.',
  legalTermsProhibited3: 'الكحول أو التبغ أو منتجات التدخين الإلكتروني أو النيكوتين أو الأسلحة أو المواد الخطرة أو المواد الخاضعة للرقابة دون التصاريح المطلوبة.',
  legalTermsProhibited4: 'الأدوية التي تتطلب وصفة طبية أو المنتجات الطبية أو السلع الخاضعة للتنظيم دون الموافقات المطلوبة.',
  legalTermsProhibited5: 'المواد الخاصة بالبالغين أو المخلة أو المسيئة أو السياسية أو المقيدة دينياً أو المخالفة للآداب العامة.',
  legalTermsProhibited6: 'الاحتيال أو غسل الأموال أو الطلبات الوهمية أو إساءة استخدام الدفع عند الاستلام أو محاولة تجاوز رسوم المنصة.',
  legalTermsProhibited7: 'استخراج أو نسخ أو عكس هندسة أو إعادة نشر محتوى موبي مارت دون إذن كتابي.',
  legalTermsProhibited8: 'أي نشاط محظور بموجب قوانين ولوائح دولة قطر.',

  legalTermsIPTitle: 'الملكية الفكرية',
  legalTermsIPP1: 'تعود ملكية اسم موبي مارت وشعارها وتصميم المنصة وبرامجها ومحتواها وعلامتها التجارية إلى شركة جاسبر للتجارة والمقاولات والخدمات أو الجهات المرخصة لها. ويمنح البائعون موبي مارت حقاً غير حصري لعرض محتوى المنتجات على المنصة ولأغراض التسويق ذات الصلة.',

  legalTermsLiabilityTitle: 'حدود المسؤولية',
  legalTermsLiabilityP1: 'تعمل موبي مارت كمنصة وسيطة تربط العملاء بالبائعين المستقلين. وما لم يذكر خلاف ذلك صراحة، فإن موبي مارت ليست البائع المباشر أو المصنع أو المستورد أو الموزع أو المالك للمنتجات المدرجة من قبل البائعين الخارجيين.',
  legalTermsLiabilityP2: 'إلى أقصى حد يسمح به القانون، لا تتحمل موبي مارت المسؤولية عن أي خسائر غير مباشرة أو عرضية أو خاصة أو تبعية. ولا يحد أي شيء في هذه الشروط من أي حقوق متاحة للمستهلكين بموجب القوانين المعمول بها في دولة قطر.',

  legalTermsTerminationTitle: 'إنهاء الخدمة',
  legalTermsTerminationP1: 'يجوز لموبي مارت تعليق أو إنهاء الحسابات أو القوائم أو الطلبات أو الوصول إلى المنصة إذا اشتبه في وجود احتيال أو تمت مخالفة القوانين أو انتهاك هذه الشروط أو إساءة استخدام المنصة.',

  legalTermsLawTitle: 'القانون الواجب التطبيق',
  legalTermsLawP1: 'تخضع هذه الشروط والأحكام لقوانين ولوائح دولة قطر. وتختص محاكم دولة قطر حصرياً بالنظر في أي نزاع ينشأ عن هذه الشروط أو يتعلق بها.',

  legalTermsChangesTitle: 'التعديلات على هذه الشروط',
  legalTermsChangesP1: 'يجوز لموبي مارت تحديث هذه الشروط من وقت لآخر. وسيتم نشر النسخ المحدثة على المنصة مع تاريخ سريان جديد. ويعد استمرار استخدام المنصة بعد سريان التعديلات قبولاً للشروط المحدثة.',

  legalTermsContactTitle: 'التواصل',
  legalTermsContactP1: 'للاستفسارات المتعلقة بهذه الشروط، يرجى التواصل معنا عبر',
  legalTermsContactP2: 'أو الاتصال على',
  legalTermsContactP3: 'ساعات خدمة العملاء من الأحد إلى الخميس، من الساعة 9 صباحاً حتى 10 مساءً بتوقيت قطر. تتوفر التفاصيل الكاملة في',
  legalTermsContactLink: 'صفحة التواصل',

  // ── PRIVACY POLICY ─────────────────────────────────────────────────────
  legalPrivacyTitle: 'سياسة الخصوصية',
  legalPrivacyLede: 'نحترم خصوصيتك. توضح هذه السياسة المعلومات الشخصية التي نجمعها، وأسباب جمعها، وكيفية استخدامها وحمايتها، والخيارات المتاحة لك.',
  legalPrivacyNoticeTitle: 'إشعار الخصوصية:',
  legalPrivacyNoticeText: 'باستخدامك موبي مارت، فإنك توافق على جمع ومعالجة بياناتك الشخصية وفقاً لهذه السياسة والقوانين المعمول بها في دولة قطر.',

  legalPrivacyTocWho: 'من نحن',
  legalPrivacyTocCollect: 'المعلومات التي نجمعها',
  legalPrivacyTocUse: 'كيفية استخدام معلوماتك',
  legalPrivacyTocBasis: 'الأساس القانوني للمعالجة',
  legalPrivacyTocSharing: 'مشاركة المعلومات',
  legalPrivacyTocIntl: 'نقل البيانات خارج قطر',
  legalPrivacyTocRetention: 'الاحتفاظ بالبيانات',
  legalPrivacyTocRights: 'حقوقك',
  legalPrivacyTocCookies: 'ملفات تعريف الارتباط والتتبع',
  legalPrivacyTocSecurity: 'الأمان',
  legalPrivacyTocChildren: 'الأطفال',
  legalPrivacyTocChanges: 'التعديلات',
  legalPrivacyTocContact: 'التواصل',

  legalPrivacyWhoTitle: 'من نحن',
  legalPrivacyWhoP1: 'تدار موبي مارت بواسطة شركة جاسبر للتجارة والمقاولات والخدمات، وهي شركة مسجلة في دولة قطر بموجب السجل التجاري CR-223480، ومقرها في المبنى 43، الشارع 310، المنطقة 27، الدوحة، دولة قطر.',
  legalPrivacyWhoP2: 'نحن نتحكم في البيانات الشخصية التي تتم معالجتها عبر موبي مارت. لأي استفسار حول كيفية تعاملنا مع بياناتك، يمكنك التواصل معنا عبر support@jasprmarket.com.',

  legalPrivacyCollectTitle: 'المعلومات التي نجمعها',
  legalPrivacyCollectIntro: 'قد نجمع المعلومات الشخصية ضمن الفئات التالية:',
  legalPrivacyCollectGiveTitle: 'المعلومات التي تقدمها لنا',
  legalPrivacyCollectGive1: 'بيانات الحساب مثل الاسم والبريد الإلكتروني ورقم الهاتف وكلمة المرور المخزنة بشكل آمن.',
  legalPrivacyCollectGive2: 'بيانات التوصيل مثل عنوان الشحن وأرقام الهاتف البديلة عند تقديمها.',
  legalPrivacyCollectGive3: 'بيانات البائعين مثل اسم المتجر ورقم السجل التجاري ومستندات التحقق من الهوية والمعلومات البنكية ومستندات الترخيص التجاري.',
  legalPrivacyCollectGive4: 'المراسلات مثل الرسائل المرسلة إلى خدمة العملاء أو البائعين أو ملاحظات الطلب.',
  legalPrivacyCollectGive5: 'التقييمات والمراجعات المكتوبة والمنتجات التي تمت مراجعتها.',
  legalPrivacyCollectTransTitle: 'معلومات المعاملات',
  legalPrivacyCollectTrans1: 'سجل الطلبات والمنتجات التي تم شراؤها والأسعار المدفوعة وحالة التوصيل.',
  legalPrivacyCollectTrans2: 'معلومات الدفع التي تتم معالجتها من خلال مزود خدمة الدفع، ولا نقوم بتخزين أرقام البطاقات الكاملة.',
  legalPrivacyCollectTrans3: 'طلبات الاسترجاع والاسترداد.',
  legalPrivacyCollectAutoTitle: 'المعلومات التي نجمعها تلقائياً',
  legalPrivacyCollectAuto1: 'معلومات الجهاز والاتصال مثل عنوان IP ونوع المتصفح ونوع الجهاز ونظام التشغيل.',
  legalPrivacyCollectAuto2: 'بيانات الاستخدام مثل الصفحات التي تمت زيارتها والمنتجات التي تم الضغط عليها ومدة الاستخدام ومصدر الإحالة.',
  legalPrivacyCollectAuto3: 'ملفات تعريف الارتباط والتقنيات المشابهة كما هو موضح في قسم ملفات تعريف الارتباط.',

  legalPrivacyUseTitle: 'كيفية استخدام معلوماتك',
  legalPrivacyUseIntro: 'نستخدم معلوماتك من أجل:',
  legalPrivacyUse1: 'إنشاء وإدارة حسابك.',
  legalPrivacyUse2: 'معالجة الطلبات والمدفوعات والتوصيل والاسترداد.',
  legalPrivacyUse3: 'التواصل معك بشأن الطلبات والفواتير وتحديثات الحالة وإشعارات الشحن.',
  legalPrivacyUse4: 'التحقق من هوية البائعين والامتثال لمتطلبات التحقق.',
  legalPrivacyUse5: 'تقديم خدمة العملاء والدعم.',
  legalPrivacyUse6: 'اكتشاف ومنع الاحتيال أو إساءة الاستخدام.',
  legalPrivacyUse7: 'تحسين المنصة وفهم المنتجات والخصائص الأكثر استخداماً.',
  legalPrivacyUse8: 'الامتثال للالتزامات القانونية والتنظيمية في دولة قطر.',
  legalPrivacyUse9: 'إرسال الرسائل التسويقية عند الحصول على موافقتك، ويمكنك إلغاء الاشتراك في أي وقت.',

  legalPrivacyBasisTitle: 'الأساس القانوني للمعالجة',
  legalPrivacyBasisIntro: 'نعالج معلوماتك بناءً على واحد أو أكثر من الأسس التالية:',
  legalPrivacyBasis1: 'الضرورة التعاقدية لتنفيذ الطلبات وتقديم الخدمات المطلوبة.',
  legalPrivacyBasis2: 'المصالح المشروعة لتشغيل المنصة بأمان ومنع الاحتيال وتحسين الخدمات.',
  legalPrivacyBasis3: 'الالتزام القانوني للامتثال لقوانين دولة قطر، بما في ذلك متطلبات التجارة الإلكترونية وحماية المستهلك والضرائب.',
  legalPrivacyBasis4: 'الموافقة، خاصة للرسائل التسويقية وملفات تعريف الارتباط غير الأساسية عند الاقتضاء.',

  legalPrivacySharingTitle: 'مشاركة المعلومات',
  legalPrivacySharingIntro: 'نشارك معلوماتك فقط بالقدر اللازم لتشغيل موبي مارت ومع أطراف ملزمة بحماية بياناتك:',
  legalPrivacySharingColRecipient: 'الطرف المستلم',
  legalPrivacySharingColShare: 'ما نشاركه',
  legalPrivacySharingColWhy: 'الغرض',
  legalPrivacySharingVendorsName: 'البائعون',
  legalPrivacySharingVendorsShare: 'الاسم وعنوان التوصيل ورقم الهاتف وتفاصيل الطلب.',
  legalPrivacySharingVendorsWhy: 'لتجهيز الطلب وتغليفه وتسليمه.',
  legalPrivacySharingCloudinaryShare: 'صور المنتجات والمستندات التي يتم رفعها.',
  legalPrivacySharingCloudinaryWhy: 'تخزين الصور والملفات سحابياً.',
  legalPrivacySharingResendShare: 'البريد الإلكتروني والاسم وتفاصيل الطلب للرسائل التشغيلية.',
  legalPrivacySharingResendWhy: 'إرسال رسائل البريد الإلكتروني المتعلقة بالخدمة.',
  legalPrivacySharingTapShare: 'الاسم والبريد الإلكتروني وتفاصيل الدفع عند تفعيل الدفع الإلكتروني.',
  legalPrivacySharingTapWhy: 'معالجة المدفوعات الإلكترونية.',
  legalPrivacySharingCouriersName: 'شركات الشحن والتوصيل',
  legalPrivacySharingCouriersShare: 'الاسم وعنوان التوصيل ورقم الهاتف.',
  legalPrivacySharingCouriersWhy: 'توصيل الطلب إلى العميل.',
  legalPrivacySharingGovName: 'الجهات الحكومية',
  legalPrivacySharingGovShare: 'المعلومات المطلوبة قانوناً.',
  legalPrivacySharingGovWhy: 'الامتثال للقوانين واللوائح المعمول بها في دولة قطر.',
  legalPrivacySharingNoSell: 'لا نقوم ببيع معلوماتك الشخصية للمعلنين أو وسطاء البيانات.',

  legalPrivacyIntlTitle: 'نقل البيانات خارج قطر',
  legalPrivacyIntlP1: 'قد تتم معالجة بعض البيانات أو تخزينها خارج دولة قطر باستخدام مزودي خدمات سحابية وشركاء تقنيين موثوقين. وباستخدام المنصة، يوافق المستخدم على نقل ومعالجة وتخزين بياناته الشخصية وفقاً لمعايير الخصوصية والأمان المعمول بها.',

  legalPrivacyRetentionTitle: 'الاحتفاظ بالبيانات',
  legalPrivacyRetentionIntro: 'نحتفظ بمعلوماتك فقط للمدة اللازمة للأغراض التالية:',
  legalPrivacyRetention1: 'بيانات الحساب طوال فترة نشاط الحساب ولمدة معقولة بعد إغلاقه لأغراض الدعم.',
  legalPrivacyRetention2: 'سجلات الطلبات للمدة المطلوبة بموجب القوانين التجارية والضريبية المعمول بها.',
  legalPrivacyRetention3: 'مستندات التحقق من البائعين طوال علاقة البائع بالمنصة ولمدة مطلوبة قانوناً بعد انتهائها.',
  legalPrivacyRetention4: 'بيانات التسويق إلى حين إلغاء الاشتراك.',
  legalPrivacyRetention5: 'سجلات الخادم لمدة محدودة ما لم يلزم الاحتفاظ بها لأغراض أمنية أو قانونية.',

  legalPrivacyRightsTitle: 'حقوقك',
  legalPrivacyRightsIntro: 'يحق لك طلب ما يلي وفقاً للقوانين المعمول بها:',
  legalPrivacyRights1: 'الوصول إلى نسخة من المعلومات الشخصية التي نحتفظ بها عنك.',
  legalPrivacyRights2: 'تصحيح المعلومات غير الدقيقة أو غير المكتملة.',
  legalPrivacyRights3: 'حذف الحساب والبيانات الشخصية، مع مراعاة متطلبات الاحتفاظ القانونية.',
  legalPrivacyRights4: 'الاعتراض على استخدام البيانات لأغراض التسويق.',
  legalPrivacyRights5: 'الحصول على بياناتك بصيغة منظمة وقابلة للقراءة آلياً حيثما ينطبق ذلك.',
  legalPrivacyRights6: 'سحب الموافقة على المعالجة القائمة على الموافقة في أي وقت.',
  legalPrivacyRightsContact: 'لممارسة أي من هذه الحقوق، يرجى مراسلتنا عبر',
  legalPrivacyRightsResponse: 'سنرد على طلبك خلال مدة معقولة وفقاً للقانون.',

  legalPrivacyCookiesTitle: 'ملفات تعريف الارتباط والتتبع',
  legalPrivacyCookiesIntro: 'تستخدم موبي مارت ملفات تعريف الارتباط والتقنيات المشابهة لتشغيل المنصة وتحسين التجربة، وتشمل:',
  legalPrivacyCookies1: 'ملفات تعريف ارتباط أساسية لتسجيل الدخول وسلة التسوق والأمان، ولا يمكن إيقافها لأنها ضرورية لتشغيل المنصة.',
  legalPrivacyCookies2: 'ملفات تعريف ارتباط وظيفية لتذكر تفضيلات اللغة والإعدادات الأخرى.',
  legalPrivacyCookiesFuture: 'إذا أضفنا أدوات تحليل أو تتبع تسويقي مستقبلاً، فسنقوم بتحديث هذه السياسة وطلب موافقتك قبل تفعيل ملفات تعريف الارتباط غير الأساسية عند الاقتضاء.',

  legalPrivacySecurityTitle: 'الأمان',
  legalPrivacySecurityIntro: 'نستخدم تدابير تقنية وتنظيمية معقولة لحماية بياناتك، بما في ذلك:',
  legalPrivacySecurity1: 'تشفير HTTPS لجميع الاتصالات بين المتصفح وخوادمنا.',
  legalPrivacySecurity2: 'تخزين كلمات المرور بشكل مشفر وفق المعايير المتبعة.',
  legalPrivacySecurity3: 'تقييد الوصول الداخلي إلى البيانات الشخصية حسب الحاجة.',
  legalPrivacySecurity4: 'مراجعة خدمات الأطراف الثالثة التي نتكامل معها بشكل دوري.',
  legalPrivacySecurity5: 'استخدام رموز المصادقة وسياسات انتهاء صلاحية مناسبة.',
  legalPrivacySecurityBreach: 'لا يوجد نظام إلكتروني آمن بنسبة مطلقة. إذا اكتشفنا خرقاً للبيانات الشخصية يؤثر عليك، فسنتخذ الإجراءات المناسبة ونخطر الجهات المعنية عند الاقتضاء وفقاً للقانون.',

  legalPrivacyChildrenTitle: 'الأطفال',
  legalPrivacyChildrenP1: 'موبي مارت غير مخصصة للمستخدمين دون سن 18 عاماً دون إشراف ولي الأمر أو الوصي القانوني. إذا كنت تعتقد أن طفلاً قدم لنا معلومات شخصية، يرجى التواصل معنا عبر',
  legalPrivacyChildrenP2: 'وسنقوم باتخاذ الإجراءات المناسبة لحذفها.',

  legalPrivacyChangesTitle: 'التعديلات',
  legalPrivacyChangesP1: 'يجوز لنا تحديث سياسة الخصوصية من وقت لآخر. وسيتم نشر النسخة المحدثة على المنصة مع تاريخ سريان جديد.',

  legalPrivacyContactTitle: 'التواصل',
  legalPrivacyContactP1: 'للاستفسارات أو الطلبات المتعلقة بالخصوصية:',
  legalPrivacyContactP2: 'الهاتف:',
  legalPrivacyContactP3: 'العنوان:',

  // ── REFUND POLICY ──────────────────────────────────────────────────────
  legalRefundTitle: 'سياسة الاسترجاع والاسترداد',
  legalRefundLede: 'نهدف إلى تمكينك من التسوق بثقة. توضح هذه السياسة متى يمكنك طلب الاسترجاع أو الاسترداد، وكيف تتم العملية، والمدة المتوقعة لمعالجة المبالغ المستردة.',
  legalRefundQuickSummary: 'ملخص سريع:',
  legalRefundQuickText: 'تغيير الرأي أو الإلغاء عند التوصيل قد يتم رده خلال 3 إلى 7 أيام بنكية حسب إجراءات البنك أو مزود الدفع. المنتجات المعيبة أو التالفة أو الخاطئة يمكن الإبلاغ عنها خلال 7 أيام. الضمان والاستبدال يخضعان لسياسة البائع أو العلامة التجارية.',

  legalRefundTocWhen: 'متى يمكنك إرجاع منتج',
  legalRefundTocConditions: 'متطلبات الحالة',
  legalRefundTocNonReturn: 'منتجات غير قابلة للإرجاع',
  legalRefundTocHow: 'كيفية الإرجاع',
  legalRefundTocMethod: 'طريقة الاسترداد والتوقيت',
  legalRefundTocShipping: 'تكلفة شحن الإرجاع',
  legalRefundTocCancel: 'إلغاء الطلبات',
  legalRefundTocCOD: 'إساءة استخدام الدفع عند الاستلام',
  legalRefundTocWarranty: 'الضمان والاستبدال',
  legalRefundTocDisputes: 'النزاعات',
  legalRefundTocContact: 'التواصل',

  legalRefundWhenTitle: 'متى يمكنك إرجاع منتج',
  legalRefundWhenIntro: 'تقبل موبي مارت طلبات الاسترجاع في الحالات التالية:',
  legalRefundChangeMindTitle: 'تغيير الرأي',
  legalRefundChangeMindIntro: 'إذا غيرت رأيك بعد الطلب أو عند وقت التوصيل، فقد يتم قبول الإلغاء أو الاسترجاع وفقاً لحالة الطلب وحالة المنتج. ويجب أن يكون المنتج:',
  legalRefundChangeMind1: 'غير مستخدم وبنفس الحالة التي تم استلامه بها.',
  legalRefundChangeMind2: 'داخل العبوة الأصلية مع جميع الملحقات والكتيبات والبطاقات.',
  legalRefundChangeMind3: 'مرفقاً بالفاتورة الأصلية أو رقم الطلب.',
  legalRefundDefectiveTitle: 'منتج معيب أو تالف أو خاطئ',
  legalRefundDefectiveIntro: 'إذا وصل المنتج معيباً أو تالفاً أو مختلفاً عن المنتج المطلوب، يمكنك الإبلاغ خلال 7 أيام من تاريخ التوصيل، وقد يتم توفير أحد الخيارات التالية حسب الحالة وسياسة البائع أو العلامة التجارية:',
  legalRefundDefective1: 'استرداد كامل أو جزئي حسب الحالة.',
  legalRefundDefective2: 'استبدال المنتج إذا كان متوفراً ووفقاً لسياسة البائع أو العلامة التجارية.',
  legalRefundDefective3: 'إصلاح المنتج حيثما ينطبق ذلك ووفقاً لسياسة الضمان.',
  legalRefundDefectiveLaw: 'لا تؤثر هذه السياسة على أي حقوق متاحة للمستهلك بموجب القوانين المعمول بها في دولة قطر.',

  legalRefundConditionsTitle: 'متطلبات الحالة',
  legalRefundConditionsIntro: 'لقبول طلب الاسترجاع، يجب أن يكون المنتج:',
  legalRefundConditions1: 'بنفس الحالة التي تم تسليمه بها، وغير مستخدم في حالات تغيير الرأي.',
  legalRefundConditions2: 'مرفقاً بالعبوة الأصلية والملحقات والكتيبات وأي هدايا مجانية.',
  legalRefundConditions3: 'تم الإبلاغ عنه من خلال قناة خدمة العملاء الخاصة بموبي مارت وليس مباشرة مع البائع فقط.',
  legalRefundConditionsP1: 'قد يتم رفض المنتجات التي يتم إرجاعها بدون عبوتها الأصلية أو مع نقص في الملحقات أو مع آثار استخدام تتجاوز الفحص الطبيعي، أو قد يتم تطبيق استرداد جزئي فقط.',

  legalRefundNonReturnTitle: 'منتجات غير قابلة للإرجاع',
  legalRefundNonReturnIntro: 'لأسباب تتعلق بالصحة والسلامة وطبيعة بعض المنتجات، لا يمكن إرجاع العناصر التالية إلا إذا كانت معيبة عند الاستلام:',
  legalRefundNonReturn1: 'سماعات الأذن أو الأجهزة الصوتية الشخصية بعد فتح التغليف.',
  legalRefundNonReturn2: 'واقيات الشاشة التي تم تركيبها أو استخدامها.',
  legalRefundNonReturn3: 'بطاقات SIM أو البطاقات مسبقة الدفع أو الرموز الرقمية بعد التفعيل.',
  legalRefundNonReturn4: 'المنتجات المحددة كبيع نهائي أو تصفية في صفحة المنتج.',
  legalRefundNonReturn5: 'المنتجات المخصصة أو المصممة حسب الطلب.',

  legalRefundHowTitle: 'كيفية الإرجاع',
  legalRefundHow1Title: 'تواصل معنا خلال المدة المؤهلة عبر البريد الإلكتروني',
  legalRefundHow1Body: 'أو اتصل على +974 6614 2417 مع ذكر رقم الطلب وسبب الاسترجاع وإرفاق صورة إذا كان المنتج تالفاً.',
  legalRefundHow2: 'انتظر التأكيد. سيقوم فريقنا بمراجعة الطلب خلال يوم عمل واحد وإرسال التعليمات ورقم مرجعي للاسترجاع.',
  legalRefundHow3: 'قم بتغليف المنتج بشكل آمن مع جميع العبوات الأصلية والملحقات.',
  legalRefundHow4: 'سلّم الطرد إلى شركة التوصيل المعتمدة عند ترتيب الاستلام.',
  legalRefundHow5: 'بعد استلام المنتج وفحصه، تبدأ عملية الاسترداد وفقاً للطريقة والمدة المطبقة.',

  legalRefundMethodTitle: 'طريقة الاسترداد والتوقيت',
  legalRefundMethodIntro: 'تتم المبالغ المستردة عادة إلى نفس وسيلة الدفع المستخدمة في الشراء أو حسب الطريقة المتاحة:',
  legalRefundMethodColPay: 'طريقة الدفع الأصلية',
  legalRefundMethodColMethod: 'طريقة الاسترداد',
  legalRefundMethodColTime: 'المدة المتوقعة',
  legalRefundMethodCODPay: 'الدفع عند الاستلام',
  legalRefundMethodCODMethod: 'تحويل بنكي إلى الحساب الذي يحدده العميل بعد التحقق.',
  legalRefundMethodCODTime: 'عادة خلال 3 إلى 7 أيام بنكية بعد الموافقة، وقد تختلف حسب البنك.',
  legalRefundMethodCardPay: 'بطاقة ائتمان أو خصم عند توفرها',
  legalRefundMethodCardMethod: 'إرجاع المبلغ إلى البطاقة الأصلية أو من خلال مزود الدفع.',
  legalRefundMethodCardTime: 'عادة خلال 3 إلى 7 أيام بنكية بعد بدء الاسترداد، وقد تستغرق بعض البنوك مدة أطول.',
  legalRefundMethodChangeMindPay: 'إلغاء بسبب تغيير الرأي بعد الطلب أو عند وقت التوصيل',
  legalRefundMethodChangeMindMethod: 'تتم المعالجة حسب وسيلة الدفع الأصلية أو التحويل البنكي عند الحاجة.',
  legalRefundMethodChangeMindTime: 'عادة خلال 3 إلى 7 أيام بنكية وفقاً لإجراءات البنك أو مزود الدفع.',
  legalRefundMethodWindow: 'تبدأ مدة المعالجة بعد الموافقة على الاسترداد أو بعد استلام المنتج وفحصه عند الحاجة. وقد تختلف المدة حسب البنك أو مزود خدمة الدفع.',

  legalRefundShippingTitle: 'تكلفة شحن الإرجاع',
  legalRefundShipping1: 'المنتجات المعيبة أو التالفة أو الخاطئة: تتحمل موبي مارت أو البائع تكلفة شحن الإرجاع حسب سبب المشكلة.',
  legalRefundShipping2: 'تغيير الرأي: قد يتحمل العميل تكلفة شحن الإرجاع أو رسوم التوصيل حسب حالة الطلب وسياسة البائع.',
  legalRefundShippingP1: 'إذا كان الطلب مؤهلاً للتوصيل المجاني وأدى الاسترجاع الجزئي إلى انخفاض قيمة الطلب عن حد التوصيل المجاني، فقد يتم خصم رسوم التوصيل المطبقة من مبلغ الاسترداد.',

  legalRefundCancelTitle: 'إلغاء الطلبات',
  legalRefundCancelP1: 'يجوز إلغاء الطلب قبل الشحن أو قبل بدء تجهيز الطلب من قبل البائع دون رسوم، متى كان ذلك ممكناً.',
  legalRefundCancelP2: 'لطلب الإلغاء، يرجى تسجيل الدخول إلى حسابك واختيار إلغاء الطلب من صفحة تفاصيل الطلب أو التواصل فوراً مع خدمة العملاء عبر',
  legalRefundCancelP3: 'في حال كان الإلغاء بسبب تغيير الرأي بعد الطلب أو عند وقت التوصيل، فسيتم رد أي مبلغ مدفوع خلال 3 إلى 7 أيام بنكية وفقاً لإجراءات البنك أو مزود الدفع، وقد يتم خصم رسوم التوصيل أو أي رسوم مطبقة إذا كان الطلب قد خرج للتوصيل.',

  legalRefundCODTitle: 'إساءة استخدام الدفع عند الاستلام',
  legalRefundCODP1: 'تحتفظ موبي مارت بالحق في تقييد أو إيقاف خدمة الدفع عند الاستلام للمستخدمين الذين يرفضون الطلبات بشكل متكرر أو يقدمون طلبات وهمية أو يسيئون استخدام نظام الطلبات أو التوصيل.',

  legalRefundWarrantyTitle: 'الضمان والاستبدال',
  legalRefundWarrantyP1: 'تخضع ضمانات المنتجات وشروط الاستبدال والإصلاح لسياسة البائع أو سياسة العلامة التجارية أو الشركة المصنعة، ما لم يذكر خلاف ذلك صراحة في صفحة المنتج.',
  legalRefundWarrantyP2: 'لا تعد موبي مارت المصنع أو الموزع أو مركز الخدمة المعتمد للمنتجات المدرجة من قبل البائعين الخارجيين، ولكنها قد تساعد العميل في التواصل مع البائع أو توجيهه إلى مركز الخدمة المناسب عند الإمكان.',
  legalRefundWarrantyP3: 'بعد انتهاء مدة الاسترجاع المحددة في هذه السياسة، يتم التعامل مع مطالبات الضمان أو الاستبدال أو الإصلاح وفقاً لشروط البائع أو العلامة التجارية أو الشركة المصنعة.',

  legalRefundDisputesTitle: 'النزاعات',
  legalRefundDisputesP1: 'إذا لم تكن راضياً عن نتيجة طلب الاسترجاع أو الاسترداد، يرجى التصعيد إلى',
  legalRefundDisputesP2: 'مع كتابة كلمة تصعيد ورقم التذكرة الأصلي في عنوان الرسالة. سنقوم بمراجعة الحالة خلال مدة معقولة.',
  legalRefundDisputesP3: 'إذا لم يتم حل المشكلة، يجوز لك التواصل مع الجهات المختصة بحماية المستهلك في دولة قطر عبر الخط الساخن',
  legalRefundDisputesP4: 'أو من خلال القنوات الرسمية المعتمدة. لا تؤثر هذه السياسة على حقوقك القانونية كمستهلك.',

  legalRefundContactTitle: 'التواصل',
  legalRefundContactP1: 'لجميع استفسارات الاسترجاع أو الاسترداد: البريد الإلكتروني',
  legalRefundContactP2: 'الهاتف',
  legalRefundContactP3: 'ساعات العمل: من الأحد إلى الخميس، من 9 صباحاً إلى 10 مساءً بتوقيت قطر',

  // ── SHIPPING POLICY ────────────────────────────────────────────────────
  legalShippingTitle: 'سياسة الشحن والتوصيل',
  legalShippingLede: 'نوفر التوصيل داخل دولة قطر خلال مدة تقديرية تتراوح بين 1 إلى 3 أيام عمل، مع توصيل مجاني للطلبات التي تتجاوز 1000 ريال قطري ما لم يذكر خلاف ذلك.',
  legalShippingGlance: 'لمحة سريعة:',
  legalShippingGlanceText: 'التوصيل متاح داخل دولة قطر. المدة التقديرية 1 إلى 3 أيام عمل. التوصيل مجاني للطلبات التي تزيد عن 1000 ريال قطري، ورسوم 15 ريالاً قطرياً للطلبات الأقل، ما لم يذكر خلاف ذلك.',

  legalShippingTocCoverage: 'نطاق التوصيل',
  legalShippingTocTiming: 'مواعيد التوصيل',
  legalShippingTocCost: 'رسوم الشحن',
  legalShippingTocProcessing: 'معالجة الطلب',
  legalShippingTocTracking: 'تتبع الطلب',
  legalShippingTocReceiving: 'استلام الطلب',
  legalShippingTocFailed: 'فشل التوصيل',
  legalShippingTocAddress: 'تغيير العنوان',
  legalShippingTocForceMajeure: 'القوة القاهرة',
  legalShippingTocContact: 'التواصل',

  legalShippingCoverageTitle: 'نطاق التوصيل',
  legalShippingCoverageIntro: 'توفر موبي مارت خدمات التوصيل داخل دولة قطر، بما في ذلك:',
  legalShippingCoverage1: 'الدوحة والمناطق الحضرية التابعة لها.',
  legalShippingCoverage2: 'الوكرة، الخور، الضعاين، الريان، أم صلال.',
  legalShippingCoverage3: 'الشحانية، الشمال والمناطق السكنية الأخرى داخل قطر.',
  legalShippingCoverage4: 'مسيعيد، دخان وبعض المناطق الخارجية حسب توفر خدمة التوصيل.',
  legalShippingCoverageRemote: 'قد تتطلب بعض المناطق البعيدة أو المقيدة وقتاً إضافياً للتوصيل. وإذا تعذر على شركة التوصيل الوصول إلى العنوان، سيتواصل فريق خدمة العملاء معك لترتيب بديل مناسب.',
  legalShippingCoverageNoIntl: 'لا نوفر حالياً الشحن خارج دولة قطر.',

  legalShippingTimingTitle: 'مواعيد التوصيل',
  legalShippingTimingIntro: 'مدة التوصيل القياسية تقديرية وتتراوح عادة بين 1 إلى 3 أيام عمل من تاريخ تأكيد الطلب.',
  legalShippingTimingColPlaced: 'وقت تقديم الطلب',
  legalShippingTimingColExpected: 'التوصيل المتوقع',
  legalShippingTimingSunWedPlaced: 'من الأحد إلى الأربعاء',
  legalShippingTimingSunWedExpected: 'خلال 1 إلى 3 أيام عمل',
  legalShippingTimingThuPlaced: 'الخميس بعد الساعة 2 مساءً',
  legalShippingTimingThuExpected: 'قد يبدأ التوصيل من يوم الأحد التالي',
  legalShippingTimingFriSatPlaced: 'الجمعة والسبت',
  legalShippingTimingFriSatExpected: 'قد يبدأ التوصيل من يوم الأحد التالي',
  legalShippingTimingBusiness: 'أيام العمل هي من الأحد إلى الخميس، باستثناء العطلات الرسمية في دولة قطر.',
  legalShippingTimingPeak: 'قد يستغرق التوصيل وقتاً أطول خلال المواسم المزدحمة أو العطلات أو الظروف الجوية أو التشغيلية غير الاعتيادية، وسيتم إخطارك عند وجود تأخير جوهري.',

  legalShippingCostTitle: 'رسوم الشحن',
  legalShippingCostColValue: 'قيمة الطلب',
  legalShippingCostColCost: 'رسوم الشحن',
  legalShippingCostAbove: 'أكثر من 1000 ريال قطري',
  legalShippingCostAboveValue: 'مجاني',
  legalShippingCostBelow: '1000 ريال قطري أو أقل',
  legalShippingCostBelowValue: '15 ريالاً قطرياً',
  legalShippingCostP1: 'يتم عرض رسوم الشحن بوضوح أثناء عملية الدفع قبل تأكيد الطلب. وقد تختلف الرسوم حسب موقع التوصيل أو فئة المنتج أو سياسة البائع عند الاقتضاء.',

  legalShippingProcessingTitle: 'معالجة الطلب',
  legalShippingProcessingIntro: 'بعد تقديم الطلب، تتم العملية عادة كما يلي:',
  legalShippingProcessing1: 'يتم إرسال تأكيد الطلب إلى العميل.',
  legalShippingProcessing2: 'يتلقى البائع إشعاراً لتجهيز المنتج.',
  legalShippingProcessing3: 'يقوم البائع بتغليف المنتج وتسليمه إلى شركة التوصيل أو ترتيب التسليم.',
  legalShippingProcessing4: 'يتم تحديث حالة الطلب عند انتقاله بين المراحل.',
  legalShippingProcessing5: 'تقوم شركة التوصيل بتسليم الطلب إلى العنوان المحدد.',

  legalShippingTrackingTitle: 'تتبع الطلب',
  legalShippingTrackingP1: 'يمكنك متابعة حالة الطلب من خلال حسابك في موبي مارت، وقد يتم إرسال تحديثات الحالة عبر البريد الإلكتروني أو القنوات المتاحة.',
  legalShippingTracking1: 'قيد الانتظار — تم تقديم الطلب وينتظر تأكيد البائع.',
  legalShippingTracking2: 'تم التأكيد — قبل البائع الطلب ويقوم بتجهيزه.',
  legalShippingTracking3: 'تم الشحن — تم تسليم الطلب إلى شركة التوصيل.',
  legalShippingTracking4: 'تم التسليم — تم استلام الطلب من قبل العميل.',

  legalShippingReceivingTitle: 'استلام الطلب',
  legalShippingReceivingIntro: 'عند وصول الطلب:',
  legalShippingReceiving1: 'يرجى فحص الطرد قبل تأكيد الاستلام، وتسجيل أي تلف ظاهر إن وجد.',
  legalShippingReceiving2: 'بالنسبة لطلبات الدفع عند الاستلام، يرجى تجهيز المبلغ المطلوب بالريال القطري.',
  legalShippingReceiving3: 'قد يطلب من العميل إبراز إثبات هوية عند استلام المنتجات ذات القيمة العالية.',
  legalShippingReceivingIssue: 'إذا كانت هناك مشكلة في الطلب مثل منتج خاطئ أو تلف أثناء النقل أو نقص في الملحقات، يرجى اتباع الخطوات الموضحة في',
  legalShippingReceivingRefund: 'سياسة الاسترجاع والاسترداد',
  legalShippingReceivingIssue2: ' خلال المدة المحددة في السياسة.',

  legalShippingFailedTitle: 'فشل التوصيل',
  legalShippingFailedIntro: 'قد تعتبر عملية التوصيل فاشلة إذا تعذر الوصول إلى العميل أو كان العنوان غير صحيح أو كان الوصول إلى الموقع غير متاح. وفي هذه الحالة قد تقوم شركة التوصيل بما يلي:',
  legalShippingFailed1: 'محاولة التوصيل مرة أخرى في يوم عمل لاحق.',
  legalShippingFailed2: 'التواصل معك على رقم الهاتف المسجل.',
  legalShippingFailed3: 'إعادة الطلب إلى المنشأة بعد محاولات فاشلة متكررة.',
  legalShippingFailedP1: 'إذا أعيد الطلب إلينا بسبب تعذر التوصيل، سيتواصل فريق خدمة العملاء معك لترتيب توصيل جديد وقد تطبق رسوم إضافية أو يتم إلغاء الطلب وفقاً للحالة.',

  legalShippingAddressTitle: 'تغيير العنوان',
  legalShippingAddressP1: 'يمكن تغيير عنوان التوصيل فقط قبل تأكيد الطلب أو شحنه. وبعد انتقال الطلب إلى مرحلة التجهيز أو الشحن، قد لا يكون تغيير العنوان ممكناً.',

  legalShippingForceMajeureTitle: 'القوة القاهرة',
  legalShippingForceMajeureP1: 'لا تتحمل موبي مارت أي مسؤولية عن أي تأخير أو إخفاق ناتج عن ظروف خارجة عن السيطرة المعقولة، بما في ذلك الأحوال الجوية القاسية أو القيود الحكومية أو حالات الطوارئ العامة أو انقطاع الإنترنت أو اضطرابات النقل أو الإضرابات أو الانقطاعات التشغيلية.',

  legalShippingContactTitle: 'التواصل',
  legalShippingContactP1: 'لاستفسارات الشحن أو التوصيل: البريد الإلكتروني',
  legalShippingContactP2: 'الهاتف',
  legalShippingContactP3: 'ساعات العمل: من الأحد إلى الخميس، من 9 صباحاً إلى 10 مساءً بتوقيت قطر',

  // ── CONTACT US ─────────────────────────────────────────────────────────
  legalContactMetaCare: 'خدمة العملاء',
  legalContactTitle: 'اتصل بنا',
  legalContactLede: 'نحن هنا لمساعدتك. سواء كان لديك سؤال عن طلب أو ترغب في أن تصبح بائعاً أو تحتاج إلى مساعدة في الاسترجاع، فهذه هي أسرع طرق التواصل معنا.',

  legalContactCardEmail: 'البريد الإلكتروني',
  legalContactCardEmailNote: 'يتم الرد خلال يوم عمل واحد عادة.',
  legalContactCardPhone: 'الهاتف',
  legalContactCardPhoneNote: 'الأحد–الخميس، 9 صباحاً – 10 مساءً بتوقيت قطر.',
  legalContactCardAddress: 'العنوان',
  legalContactCardAddressLine1: 'المبنى 43، الشارع 310، المنطقة 27',
  legalContactCardAddressLine2: 'الدوحة، دولة قطر',
  legalContactCardAddressNote: 'الزيارات بموعد مسبق فقط.',

  legalContactWhoTitle: 'من تتواصل معه حسب نوع الطلب',
  legalContactWhoIntro: 'لخدمة أسرع، يرجى التواصل مع القسم المناسب حسب نوع الاستفسار.',
  legalContactWhoColAbout: 'سؤالك يتعلق بـ…',
  legalContactWhoColEmail: 'راسل هذا العنوان',
  legalContactWhoOrders: 'حالة الطلب أو التوصيل أو المدفوعات',
  legalContactWhoSupport: 'الاسترجاع أو الاسترداد أو الشكاوى',
  legalContactWhoSales: 'الانضمام كبائع أو تسجيل متجر',
  legalContactWhoInfo: 'الاستفسارات العامة أو الشراكات أو الإعلام',
  legalContactWhoPrivacy: 'الخصوصية أو طلبات البيانات أو حذف الحساب',

  legalContactHoursTitle: 'ساعات دعم العملاء',
  legalContactHoursIntro: 'يرد فريقنا على الهاتف والبريد الإلكتروني خلال الأوقات التالية:',
  legalContactHours1: 'من الأحد إلى الخميس: من الساعة 9:00 صباحاً حتى 10:00 مساءً بتوقيت قطر.',
  legalContactHours2: 'الجمعة والسبت: مغلق، ويتم الرد على الرسائل الواردة خلال عطلة نهاية الأسبوع في يوم العمل التالي.',
  legalContactHours3: 'العطلات الرسمية: مغلق.',
  legalContactHoursUrgent: 'للمشاكل العاجلة المتعلقة بالتوصيل خارج ساعات العمل، يرجى إرسال بريد إلكتروني وسنقوم بالمراجعة عند الإمكان.',

  legalContactResponseTitle: 'أوقات الاستجابة',
  legalContactResponse1: 'البريد الإلكتروني: يتم الرد الأول عادة خلال يوم عمل واحد.',
  legalContactResponse2: 'الهاتف: متاح خلال ساعات الدعم.',
  legalContactResponse3: 'طلبات الاسترجاع: تتم مراجعتها عادة خلال يوم عمل واحد من استلام الطلب.',
  legalContactResponse4: 'اعتماد البائعين: يتم بعد استلام جميع مستندات التحقق المطلوبة ومراجعتها.',

  legalContactVendorsTitle: 'للبائعين',
  legalContactVendorsP1: 'إذا كنت بائعاً مسجلاً في موبي مارت، يرجى تسجيل الدخول إلى لوحة تحكم البائع للوصول إلى أدوات الدعم والتقارير وإدارة الطلبات.',
  legalContactVendorsP2: 'إذا كنت ترغب في البيع عبر موبي مارت، يرجى مراسلتنا عبر',
  legalContactVendorsP3: 'مع تزويدنا بما يلي:',
  legalContactVendors1: 'اسم النشاط التجاري ورقم السجل التجاري.',
  legalContactVendors2: 'فئات المنتجات التي تبيعها.',
  legalContactVendors3: 'حجم المبيعات الشهري المتوقع.',
  legalContactVendors4: 'اسم جهة الاتصال ورقم الهاتف.',
  legalContactVendorsPricing: 'رسوم البائعين: 1000 ريال قطري رسوم إعداد، 250 ريالاً قطرياً اشتراك شهري، و500 ريال قطري رسوم تجديد سنوية.',

  legalContactComplaintsTitle: 'الشكاوى والتصعيد',
  legalContactComplaintsP1: 'إذا تواصلت معنا ولم يتم حل مشكلتك، يرجى مراسلتنا عبر',
  legalContactComplaintsP2: 'مع كتابة كلمة تصعيد ورقم التذكرة الأصلي في عنوان الرسالة. سيقوم أحد أعضاء الفريق بمراجعة الحالة خلال مدة معقولة.',
  legalContactComplaintsP3: 'إذا لم يتم حل المشكلة بعد التصعيد، يحق لك تقديم شكوى لدى الجهات المختصة بحماية المستهلك في دولة قطر عبر الخط الساخن',
  legalContactComplaintsP4: 'أو من خلال القنوات الرسمية المعتمدة.',

  legalContactCompanyTitle: 'بيانات الشركة',
  legalContactCompanyP1: 'تدار موبي مارت بواسطة:',
  legalContactCompanyCR: 'السجل التجاري:',
  legalContactCompanyAddr: 'العنوان:',
  legalContactCompanyPhone: 'الهاتف:',
  legalContactCompanyWeb: 'الموقع:',
}
export { legalEN, legalAR }